import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { PayoffReviewEmbed } from '@roc/feature-lien-payoff';

export const getPayoffReviewInternalRoutesConfig = (
  basePath: string,
  baseUrl: string,
) => {
  return {
    payoffReviewV2: {
      path: `${basePath}/payoff-review-v2`,
      url: `${baseUrl}/payoff-review-v2`,
      documentTitle: 'payoff-review-v2',
    },
  };
};

export const getPayoffReviewInternalRoutes = (
  basePath: string,
  baseUrl: string,
  loanId: any,
  propertyId: any,
  readOnly: any
) => {
  const config = getPayoffReviewInternalRoutesConfig(basePath, baseUrl);

  return {
    payoffReviewV2: (
      <Route exact path={config.payoffReviewV2.path}>
        <Page routeDefinition={config.payoffReviewV2}>
          <PayoffReviewEmbed
            loanId={loanId}
            propertyId={propertyId}
            readOnly={readOnly === "true"}
          />
        </Page>
      </Route>
    ),
  };
}
